<template>
  <b-row>
    <b-col sm="12" class="text-center">
      <i class="fa fax fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></i>
      <p>
        {{ message }}
      </p>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: 'FormLoader',
  props: {
    message: {
      type: String,
      default: 'Een moment geduld...'
    },
  }
}
</script>